import { createContext } from 'react';
export const PopoverPrimitiveHoverGroupContext = createContext(null);
//# sourceMappingURL=PopoverPrimitiveHoverGroupContext.js.map